import React from 'react';
import styles from './mainNavigationStepper.module.css';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {
    StyledMainStepper,
    StyledButton,
    StyledStep,
    StyledStepLabel,
} from './styledMaterialComponents';
import {showLoginModal} from '../../store/index';
import {connect} from 'react-redux';
import {FORM_PAGES_LABELS, FORM_PAGES_NUMBERS} from '../../constants/formPages';

const MainNavigationStepper = ({
    nextPageHandler,
    previousPageHandler,
    activePage,
    showLoginModal,
    userLogged,
    currentStepError,
    nextPageClicked,
}) => {
    const mapSteps = () =>
        FORM_PAGES_LABELS.map((label, index) => {
            const labelProps = {};
            if (index === activePage && nextPageClicked) {
                labelProps.error = currentStepError;
            }
            if (index < activePage) {
                labelProps.completed = true;
            }
            return (
                <StyledStep key={label}>
                    <StyledStepLabel {...labelProps}>{label}</StyledStepLabel>
                </StyledStep>
            );
        });

    const nextStepWithValidationHandler = () => {
        nextPageHandler();
    };

    const previousPageWithValidationHandler = () => {
        previousPageHandler();
    };

    return (
        <div className={styles.mainNavigationStepper}>
            <div className={styles.constrolBar}>
                <StyledButton
                    disabled={
                        activePage === 0 ||
                        activePage === FORM_PAGES_NUMBERS.subscriptionPlaced
                    }
                    onClick={previousPageWithValidationHandler}
                    variant="contained"
                    color="primary">
                    <KeyboardArrowLeft />
                    Powrót
                </StyledButton>
                {userLogged ? (
                    <p>Jesteś zalogowany</p>
                ) : (
                    <StyledButton
                        disabled={
                            activePage === FORM_PAGES_NUMBERS.subscriptionPlaced
                        }
                        variant="contained"
                        color="primary"
                        onClick={showLoginModal}>
                        Zaloguj
                    </StyledButton>
                )}
                <StyledButton
                    disabled={
                        activePage === FORM_PAGES_NUMBERS.subscriptionPlaced
                    }
                    onClick={nextStepWithValidationHandler}
                    variant="contained"
                    color="primary">
                    Dalej
                    <KeyboardArrowRight />
                </StyledButton>
            </div>
            <div className={styles.stepperWraper}>
                <StyledMainStepper activeStep={activePage}>
                    {mapSteps()}
                </StyledMainStepper>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    userLogged: !!state.auth.userDetails,
});

const mapDispatchToProps = {
    showLoginModal,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MainNavigationStepper);
